import { useInfiniteQuery } from '@tanstack/react-query'
import { getSearchOffices } from "../api/get-search-offices"

export const useGetSearchOffices = ({ params, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-search-offices', params],
    queryFn: ({ pageParam = 1 }) => getSearchOffices({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}
